import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M13.5,9.809,8.75,7.22V4.453h.782c.3,0,.382-.208.187-.463L8.354,2.211a.424.424,0,0,0-.709,0L6.281,3.99c-.195.255-.111.463.186.463H7.25V7.22L2.5,9.809a.749.749,0,0,0,0,1.319L7.645,13.89c.009,0,.02,0,.029.007a.682.682,0,0,0,.652,0c.009,0,.02,0,.029-.007L13.5,11.128a.749.749,0,0,0,0-1.319ZM7.25,8.928v3.048L4.433,10.463Zm1.5,3.048V8.928l2.817,1.535Z';
const draw24px =
  'M21.306,15.845l-8.548-4.558V4.678L14.88,6.8a.75.75,0,0,0,1.06-1.06l-3.4-3.4a.773.773,0,0,0-1.061,0l-3.4,3.4A.75.75,0,0,0,9.137,6.8l2.121-2.122v6.653L2.7,15.843a.75.75,0,0,0,.007,1.331l9,4.625a.752.752,0,0,0,.689,0l8.9-4.626a.749.749,0,0,0,.008-1.327ZM11.258,19.881,4.672,16.5l6.586-3.471Zm1.5.039V12.987L19.343,16.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const AddZPlaneIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'addZPlane'),
) as IconWithRender;

AddZPlaneIcon.displayName = 'AddZPlaneIcon';
AddZPlaneIcon.propTypes = Icon.propTypes;
AddZPlaneIcon.renderIcon = (props) => <AddZPlaneIcon {...props} />;
export default AddZPlaneIcon;
